import React, { useEffect, useState } from "react";
import {
  PageHeader,
  Tabs,
} from "antd";

import CreateAdjustment from "./CreateAdjustment";
import DraftList from "./DraftList";

import AdjustStatus from "./AdjustStatus";
import DownloadAll from "./DownloadAll";
import util from "helpers/util";

const { TabPane } = Tabs;

export default function StockAdjustment() {
  const [tabActiveKey, setTabActiveKey] = useState("1");
  const [editDraftNumber, setEditDraftNumber] = useState(null);
  const urlDetail = util.getCurrentUrlDetail();
  const decodePath = decodeURIComponent(urlDetail.subPath ?? "");

  useEffect(() =>{
    if (decodePath == "draft") {
      setTabActiveKey("2");
    } else if(decodePath == "submitted"){
      setTabActiveKey("3");
    }
  },[])

  const callbackTab = (key) => {
    setTabActiveKey(key);
  };

  const editDraftFromList = (draftNumber) => {
    setEditDraftNumber(draftNumber);
    setTabActiveKey("1");
  }

  const onDone = () => {
    setEditDraftNumber(null);
  }

  return (
    <>
      <PageHeader title="Stock Adjustment" />
      <br />
      <Tabs
        defaultActiveKey="1"
        activeKey={tabActiveKey}
        onChange={callbackTab}
        type="card"
        size="large"
      >
        <TabPane tab="Create Adjust" key="1">
          <CreateAdjustment onDone={onDone} draftNumberEdit={editDraftNumber} />
        </TabPane>

        <TabPane tab="Draft Lists" key="2">
          <DraftList editDraftFromList={editDraftFromList} />
        </TabPane>

        <TabPane tab="Adjust Status" key="3">
          <AdjustStatus />
        </TabPane>

        <TabPane tab="Download All" key="4">
          <DownloadAll />
        </TabPane>
        
      </Tabs>
    </>
  );
}
